<template lang="pug">
    include ../../media/pug/mixins.pug
    +b.login-box
        +e.inner
            template(v-if='!getGeneralInfo.isLogin')
                +e.header
                    +e.H3.title.title._size_md Личный кабинет
                +e.body._gutter
                    +e.A.btn.btn._theme_transp
                        span.btn__text Войти
                    +e.A.btn.btn._theme_fill
                        span.btn__text Зарегистрироваться
            +e.body(v-else)
                rsl-user-menu(
                    v-bind:logoutLink="logoutLink"
                    v-bind:userName="getUserName"
                    v-bind:infoLinks="[]"
                )
            +e.footer
                +e.BUTTON.close.btn(type='button' v-on:click='close')
                    +e.V-ICON.close-icon(name="done-circle")
                    +e.close-text {{ $t('CLOSE') }}
        +e.bg(v-on:click='close')

</template>

<script>

import { mapGetters } from 'vuex';
import RslUserMenu from '@RSL/RslUserMenu/RslUserMenu';
import entry from '@/helpers/mixins/entry';

export default {
    components: {
        RslUserMenu
    },
    mixins: [entry],
    computed: {
        ...mapGetters([
            'getGeneralInfo',
            'getUserName'
        ])
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/partials/login-box.sass"></style>
